/**
 * Short description for file
 *
 * Author: H.R. Shadhin <dev@hrshadhin.me>
 *
 * LICENSE: AGP 3.0
 *
 * DATE: 3/6/19
 * TIME: 7:44 PM
 */
import Generic from "./Generic";
import Academic from "./Academic";

export default class Account {

    static feeInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();
    }
    static budgetInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();
        if($('select[name="academic_year"] option[selected]').text().length) {
            $('title').text($('title').text() + '-' + +'(' + $('select[name="academic_year"] option[selected]').text() + ')');
        }

        $('select[name="academic_year"]').on('change', function () {
            let ac_year = $('select[name="academic_year"]').val();
            if(!ac_year){
                return false;
            }

            let urlLastPart ="?academic_year="+ac_year;
            let getUrl = window.location.href.split('?')[0]+urlLastPart;
            window.location = getUrl;

        });

    }


    static claimDocs(){
         $('.btnClaimDeatils').click(function () {
            let pk = $(this).attr('data-pk');
            let getUrl = window.claimListUrl.replace(/\.?0+$/, pk);
            $('#paymentListTable tbody').empty();
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    if(response.data.success){
                        response.data.payments.forEach(function(payment, index) {
                            let trRow = '<tr>\n' +
                                '<td>'+(index + 1)+'</td>\n';

                               if(payment.member_id_copy.length){
                                   trRow += '<a href="/storage/claim/'+payment.member_id_copy+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }


                               if(payment.deceased_copy.length){
                                   trRow += '<a href="/storage/claim/'+payment.deceased_copy+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }


                               if(payment.mortuary_file.length){
                                   trRow += '<a href="/storage/claim/'+payment.mortuary_file+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }


                               if(payment.death_certificate.length){
                                   trRow += '<a href="/storage/claim/'+payment.death_certificate+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }


                               if(payment.birth_certificate.length){
                                   trRow += '<a href="/storage/claim/'+payment.birth_certificate+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }


                               if(payment.marriage_certificate.length){
                                   trRow += '<a href="/storage/claim/'+payment.marriage_certificate+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }

                                '</tr>';
                            $('#paymentListTable tbody').append(trRow);
                        });

                        $('#modalPaymentDetails').modal('show');
                    }
                    else{
                        toastr.error(response.data.message);
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });

    }

static statementInit(){
Generic.initCommonPageJS();
Generic.initDeleteDialog();

       $('input#regi_no').on('blur',function () {
            $('select[name="product_id"]').empty().select2({placeholder: 'Pick a loan type...'});
            let isProduct = $('input[name="is_product"]').val();

            let whichInput = $(this).attr('id');
            let urlParams = "";
            if(whichInput == "regi_no"){
                let regiNo = $(this).val();
                if(!regiNo.length){
                    toastr.warning('write regi. no!');
                    return false;
                }
                urlParams = "?regi_no="+regiNo+"&is_product="+isProduct;
            }
            
            let getUrl = window.getProductsAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    let products = response.data;
                    if (products.length) {
                        let product = products[0];
                        


                        $.each(response.data, function(key, value){
                            $('select[name="product_id"]').append("<option value='" + value.id + "'>"+value.name+"</option>").select2();
                        });
                         $('select[name="product_id"]').val(product.id).trigger('change')

                    }
                    else {
                        toastr.error('no data found!');
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });



       $('select[name="product_id"]').on('change', function () {

            let type_id = $(this).val();
            let member_id = $('input[name="regi_no"]').val();

            Account.getLoanRef(type_id, member_id);

        });
}


 static getLoanRef(type_id, member_id) {
    let urlParams = "?type_id="+type_id+"&regi_no="+member_id;
        let getUrl = window.loan_list_url + urlParams;
        if (type_id) {
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    if (Object.keys(response.data).length) {
                        
                        $('select[name="loan_id"]').empty().prepend('<option selected=""></option>').select2({ allowClear: true, placeholder: 'Pick loan ref...', data: response.data });
                    }
                   
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();

            });
        }
        else {
            // clear section list dropdown
            $('select[name="section_id"]').empty().select2({ placeholder: 'Pick a section...' });
        }
    }




    static withdrawInit(){
      Generic.initCommonPageJS();
        Generic.initDeleteDialog();  

        $('select[name="product_id"]').on('change', function () {
            let member_id = $('input[name="member_id"]').val();
            let product_id = $(this).val();
            let urlParams = "?member_id="+member_id+"&product_id="+product_id;
            let getUrl = window.saving_list_url + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                let prod = response.data.product;
                 $('#avialableSavings').val(response.data.amount);
                 let max = response.data.amount - prod.min_balance;
                 $("#amount").attr({
                    "max" : max,        
                    "min" : prod.withdrawal_limit         
                     });

                 Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });


        });
    }

    static loanInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();

      $('select[name="product_id"]').on('change', function () {
            let member_id = $('input[name="member_id"]').val();
            let loan_id = $(this).val();
            if (!member_id) {
                return false;
            }

            if (!loan_id) {
                return false;
            }


          let getUrl = window.getMemberLoanStatusAjaxUrl.slice(0, -3) + member_id + '/' + loan_id;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                let prod = response.data.product;
                let insu = response.data.insurance;
                let runningLoan = response.data.runningLoan;

                if(runningLoan){
                    if(prod.new_loan_perc > response.data.progress){
                      $('#message').show();
                       $('#feeStatus').text('You are not eligeble for this loan, you have a running loan amount E'+runningLoan.amount_required +' which is '+ response.data.progress.toFixed(0)+'% paid. Pay atleast '+prod.new_loan_perc+'% of the loan!');
                       //$('select[name="product_id"]').val('').trigger('change');
                       $('select[name="product_id"]').val('').change();
                       $('input[name="loan_amount"]').val('');
                       $('input[name="amount_required"]').val('');
                       $('input[name="amount_available"]').val('');
                       $('input[name="loan_limit"]').val('');
                       $('input[name="available_savings"]').val('');
                       $('input[name="current_loan"]').val('');
                       $('input[name="interes_rate"]').val('');

                       $('input[name="LoanTerm"]').val('');
                       $('input[name="risk_fee"]').val('');
                       $('input[name="security"]').val('');
                       $('input[name="admin_fees"]').val('');
                       $('input[name="application_fees"]').val('');

                       $('input[name="1st_repayment_date"]').val('');
                       $('input[name="LoanDate"]').val('');
                       $('input[name="payment_soyrce"]').val('');
                       $('input[name="insurance"]').val('');
                       $('input[name="LoanInstall"]').val('');
                       $('input[name="payout_after_settlement"]').val('');
                       $('input[name="settlement_fee"]').val('');
                       $('input[name="prev_loan_id"]').val('');
                       Generic.loaderStop();
                       return false;
                    }

                }


                    if(prod.loan_amount_min > response.data.serving){
                        //toastr.error('You are not eligeble for this loan, available serving of '+response.data.serving+' is less than minimum required balance !');
                        $('#message').show();
                       $('#feeStatus').text('You are not eligeble for this loan, available serving of E'+response.data.serving+' is less than minimum required balance of E'+prod.loan_amount_min);
                       Generic.loaderStop();
                       return false;
                        }else{
                       $('#message').hide(); 
                        }
                        let available = response.data.serving * prod.loan_multiple;
                        let limit = available - response.data.loan - response.data.insurance;
                        let required = limit + response.data.loan + response.data.insurance;
                        let rA = response.data.loan + prod.loan_amount_min;
                        if(limit > prod.loan_amount_max){
                            $('#limitAmount').val(prod.loan_amount_max)
                            $('#amountAvailable').val(prod.loan_amount_max)

                            $("#payoutAmount").attr({
                            "max" : prod.loan_amount_max,        
                            "min" : prod.loan_amount_min         
                            });

                            $("#amountRequired").attr({
                            "max" : prod.loan_amount_max,        
                            "min" : prod.loan_amount_min         
                            });

                            

                        }else{
                          $('#limitAmount').val(limit)
                          $('#amountAvailable').val(limit) 

                         

                          $("#payoutAmount").attr({
                            "max" : limit,        
                            "min" : prod.loan_amount_min          
                            }); 
                          

                          $("#amountRequired").attr({
                            "max" : required,        
                            "min" : prod.loan_amount_min         
                            });
                        }
                        $('#avialableSavings').val(response.data.serving)
                        $('#tenure').val(response.data.tenure)
                        $('#interestRate').val(prod.interest_rate)
                        $('#currentLoan').val(response.data.loan)
                        $('#prev_loan_id').val(response.data.loan_id)
                        if(response.data.insurance){
                          $('#insurance').val(response.data.insurance.toFixed(2))
                        }else{
                           $('#insurance').val(0.00)
                        }

                    
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });



      $('input#payoutAmount').on('blur',function () {

        let urlParams = "";
        let interest = $('input[name="interes_rate"]').val();
        let tenure = $('input[name="LoanTerm"]').val();
        let admin = $('input[name="admin_fees"]').val();
        let productId =  $('select[name="product_id"]').val();
        let prev = $('input[name="current_loan"]').val();
        let insurance = $('input[name="insurance"]').val();
        let loanAmaount = $(this).val();


                      if(!productId){
                         toastr.warning('Please select Loan Type!');
                         $('#payoutAmount').val('');
                         return false;
                        }

          urlParams = "?interes_rate="+interest+"&LoanTerm="+tenure+"&admin_fees="+admin+"&loanAmaount="+loanAmaount+"&productId="+productId+"&current_loan="+prev+"&insurance="+insurance;
           let getUrl = window.getMemberLoanAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                

                $('#amountRequired').val(response.data.amountR.toFixed(2));
                $('#instalment').val(response.data.instalment.toFixed(2));
                $('#amountOwing').val(response.data.topay.toFixed(2));
                $('#payoutSettlement').val(response.data.after);
                $('#settlementFee').val(response.data.fee);
                $('#tenure').val(response.data.tenure)
                  Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });


      });



        $('input#amountRequired').on('blur',function () {

        let urlParams = "";
        let interest = $('input[name="interes_rate"]').val();
        let tenure = $('input[name="LoanTerm"]').val();
        let admin = $('input[name="admin_fees"]').val();
        let productId =  $('select[name="product_id"]').val();
        let prev = $('input[name="current_loan"]').val();
        let insurance = $('input[name="insurance"]').val();
        let loanAmaount = $(this).val();


                      if(!productId){
                         toastr.warning('Please select Loan Type!');
                         $('#amountRequired').val('');
                         return false;
                        }

          urlParams = "?interes_rate="+interest+"&LoanTerm="+tenure+"&admin_fees="+admin+"&loanAmaount="+loanAmaount+"&productId="+productId+"&current_loan="+prev+"&insurance="+insurance;
           let getUrl = window.getMemberLoanInstAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                

                $('#payoutAmount').val(response.data.payoutAmount.toFixed(2));
                $('#instalment').val(response.data.instalment.toFixed(2));
                $('#amountOwing').val(response.data.topay.toFixed(2));
                $('#payoutSettlement').val(response.data.after);
                $('#settlementFee').val(response.data.fee);
                $('#tenure').val(response.data.tenure)
                  Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });


      });





      $('input#tenure').on('blur',function () {

        let urlParams = "";
        let loanAmaount = $('input[name="amount_required"]').val();
        let amountToPay = $('input[name="amount_to_be_paid"]').val();
        let productId =  $('select[name="product_id"]').val();
        let tenure = $(this).val();


                      if(!productId){
                         toastr.warning('Please select Loan Type!');
                         $('#tenure').val('');
                         return false;
                        }


                        if(!loanAmaount){
                         toastr.warning('Please enter amount required!');
                         $('#tenure').val('');
                         return false;
                        }

           urlParams = "?amount_to_pay="+amountToPay+"&loanAmaount="+loanAmaount+"&productId="+productId+"&tenure="+tenure;
           let getUrl = window.getMemberNewInstallAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                
                if(response.data.newTenure > response.data.tenure){
                    toastr.warning('months to pay can not be greater than '+response.data.tenure+ ' months');
                    $('#tenure').val(response.data.tenure);
                    
                    Generic.loaderStop();
                    return false;
                    }

                 $('#instalment').val(response.data.instalment.toFixed(2));
                
                

                  Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });


      });



       $('input#instalment').on('blur',function () {

        let urlParams = "";
        let loanAmaount = $('input[name="amount_required"]').val();
        let amountToPay = $('input[name="amount_to_be_paid"]').val();
        let productId =  $('select[name="product_id"]').val();
        let interest = $('input[name="interes_rate"]').val();
        let admin = $('input[name="admin_fees"]').val();
        let instalment = $(this).val();


                      if(!productId){
                         toastr.warning('Please select Loan Type!');
                         //$('#tenure').val('');
                         $('#instalment').val('');
                         return false;
                        }


                        if(!loanAmaount){
                         toastr.warning('Please enter amount required!');
                         $('#instalment').val('');
                         return false;
                        }

           urlParams = "?amount_to_pay="+amountToPay+"&loanAmaount="+loanAmaount+"&productId="+productId+"&instalment="+instalment+"&interes_rate="+interest+"&admin_fees="+admin;
           let getUrl = window.getMemberNewInstallAmountAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                
                if(response.data.newInstall < response.data.instalment){
                    toastr.warning('instalment amount can not be less than E'+response.data.instalment.toFixed(2));
                    $('#instalment').val(response.data.instalment.toFixed(2));
                    
                    Generic.loaderStop();
                    return false;
                    }

                 $('#tenure').val(response.data.tenure.toFixed(2));
                
                

                  Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });


      });



    }

    static invoiceInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();

        //list page js
        $('select[name="class_id"]').on('change', function () {
            let class_id = $(this).val();
            Academic.getSection(class_id);
        });
        $('#section_id_filter').on('change', function () {
            let sectionId = $(this).val();
            let classId =  $('select[name="class_id"]').val();
            let acYearId =  $('select[name="academic_year"]').val();
            //validate input
            if(!classId || !sectionId){
                return false;
            }
            //check year then procced
            if(institute_category == "college"){
                if(!acYearId) {
                    toastr.warning('Select academic year first!');
                    return false;
                }
            }
            else {
                acYearId = 0;
            }

            Generic.loaderStart();
            Academic.getStudentByAcYearAndClassAndSection(acYearId, classId, sectionId, function (data) {
                let students = data;
                if (students.length) {
                    let studentOptions = [];
                    students.forEach(function(item) {
                        studentOptions.push({
                            id: item.id,
                            text: item.student.name +'['+item.roll_no+']'
                        });
                    });
                    $('select[name="student_id"]').empty().prepend('<option selected=""></option>').select2({allowClear: true,placeholder: 'Pick a client...', data: studentOptions});
                    //now show the submit button
                    $('button[type="submit"]').show();
                }
                else {
                    $('select[name="student_id"]').empty().select2({placeholder: 'Pick a client...'});
                    toastr.error('This section have no student!');
                }
                Generic.loaderStop();
            });

        });

        //add page js
        $('#fee_type_id').select2({
            placeholder: 'select...',
            data: window.fee_types,
            allowClear: true,
            templateSelection: function (data, container) {
                $(data.element).attr('data-amount', data.amount);
                return data.text;
            }
        });


        $('.nav-tabs').on('click','li#searchByClassTab',function () {
            setTimeout(function () {
                $('select#academic_year_id').select2();
                $('select#class_id').select2({placeholder: 'Pick a class...'});
            },200);

        });

        $('select#class_id').on('change', function () {
            let class_id = $(this).val();
            let getUrl = window.section_list_url + "?class=" + class_id;
            if (class_id) {
                Generic.loaderStart();
                axios.get(getUrl)
                    .then((response) => {
                        if (Object.keys(response.data).length) {
                            $('select#section_id').empty().prepend('<option selected=""></option>').select2({allowClear: true,placeholder: 'Pick a section...', data: response.data});
                        }
                        else {
                            $('select#section_id').empty().select2({placeholder: 'Pick a section...'});
                            toastr.error('This class have no section!');
                        }
                        Generic.loaderStop();
                    }).catch((error) => {
                    let status = error.response.statusText;
                    toastr.error(status);
                    Generic.loaderStop();

                });
            }
            else {
                // clear section list dropdown
                $('select#section_id').empty().select2({placeholder: 'Pick a section...'});
            }
        });



        $('input#open_regi_no').on('blur',function () {
            $('select[name="student_id"]').empty().select2({placeholder: 'Pick a client...'});

            let whichInput = $(this).attr('id');
            let urlParams = "";
            if(whichInput == "open_regi_no"){
                let regiNo = $(this).val();
                if(!regiNo.length){
                    toastr.warning('write regi. no!');
                    return false;
                }
                urlParams = "?open_regi_no="+regiNo;
            }
            
            let getUrl = window.getOpenMemberAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    let students = response.data;
                    if (students.length) {
                        let student = students[0];
                        let studentOptions = [{
                            id: student.id,
                            text: student.name + student.surname +'['+student.id+']'
                        }];

                        $('select[name="student_id"]').empty().prepend('<option selected=""></option>').select2({allowClear: true,placeholder: 'Pick a client...', data: studentOptions});

                        $('select[name="student_id"]').val(student.id).trigger('change')

                    }
                    else {
                        toastr.error('Client Not Found!');
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });






        $('input#regi_no').on('blur',function () {
            $('select[name="student_id"]').empty().select2({placeholder: 'Pick a client...'});

            let whichInput = $(this).attr('id');
            let urlParams = "";
            if(whichInput == "regi_no"){
                let regiNo = $(this).val();
                if(!regiNo.length){
                    toastr.warning('write regi. no!');
                    return false;
                }
                urlParams = "?regi_no="+regiNo;
            }
            
            let getUrl = window.getStudentAjaxUrl + urlParams;
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    let students = response.data;
                    if (students.length) {
                        let student = students[0];
                        let studentOptions = [{
                            id: student.id,
                            text: student.company +'['+student.id+']'
                        }];

                        $('select[name="student_id"]').empty().prepend('<option selected=""></option>').select2({allowClear: true,placeholder: 'Pick a client...', data: studentOptions});

                        $('select[name="student_id"]').val(student.id).trigger('change')

                    }
                    else {
                        toastr.error('Client Not Found!');
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });

        $('.documentUp').change(function(){
            var input = this;
            var url = $(this).val();
            var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
            if (input.files && input.files[0]&& (ext == "png" || ext == "jpeg" || ext == "jpg"
                || ext == "txt" || ext == "text" || ext == "doc" || ext == "docx" || ext == "pdf" || ext == "odt" ))
            {
                //validate size
                var sizeImg =input.files[0].size/7024;
                if (sizeImg>7024) {
                    toastr.error("File is too big!");
                    $(input).val('');
                    return false
                }
            }
            else{
                $(input).val('');
            }
        });

        $('select#fee_type_id').on('select2:select', function () {
            let fee_id = $(this).val();
            let i=1;
            if(parseInt(fee_id)){
                //check fee type exists or not
                let exists = false;
                $('input[name="fee_types[]"]').each(function (index, element) {
                    if($(element).val() == fee_id){
                        exists = true;
                        return false;
                    }
                });
                 let feeName = $('#fee_type_id').find(':selected').text();

                 if(feeName == 'Loan Repayment'){
                    let member_id = $('input[name="member_id"]').val()
                    let getUrl = window.loan_list_url + "?member=" + member_id;
                       Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {

                   // console.log(response);
                    let loans = response.data;
                    if (loans.length) {

                        let loan = loans[0];
              $.each(response.data, function(key, value){
                            $(".loan_id_filter").append("<option value='" + value.id + "'>"+value.name+"-"+value.loan_num+"</option>").select2();
                        });
                        $('.loan_id_filter').val(loan.id).trigger('change')
                    }
                    else {
                        toastr.error('no active loan found!');
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });



             }
             
                 if(exists){

                    toastr.error("product already added in list!");
                    return false;
                }
                else{
                   
                    let feeAmount = $('#fee_type_id').find(':selected').data('amount');
                    let trRow = '<tr>\n' +
                        '<td>\n';
                        if(feeName != 'Loan Repayment' ){
                     trRow += ' <span class="text-bold">'+feeName+'</span>\n' +
                        '<input type="hidden" value="'+fee_id+'" name="fee_types[]">\n';
                    }else{
                    i=5;
                    trRow +='<div class="form-group row"><label for="inputCell" class="col-sm-4 col-form-label">Loan ID</label><div class="col-sm-8"><select class="form-control loan_id_filter" id="loan_id_filter" name="member_loan"></select></div></div><div class="form-group row"><label for="inputCell" class="col-sm-4 col-form-label">Loan total settlement amount</label><div class="col-sm-8"><input readonly type="number" class="form-control" name="before" id="before"></div></div><div class="form-group row"><label for="inputCell" class="col-sm-4 col-form-label">Loan balance after payment</label><div class="col-sm-8"><input readonly type="number" class="form-control" id="after" name="after"></div></div><div class="form-group row"><label for="inputCell" class="col-sm-4 col-form-label">Insurance</label><div class="col-sm-8"><input readonly id="insurance" type="number" class="form-control" name="insurance"></div></div><div class="form-group row"><label for="inputCell" class="col-sm-4 col-form-label">Settlement</label><div class="col-sm-8"><input type="number" class="form-control" id="settlement" readonly name="settlement"></div></div>\n'+ 
                    '<input type="hidden" value="'+fee_id+'" name="fee_types[]">\n';
                    }




                       trRow += '</td>\n' +
                        '<td>\n' +
                        '<input type="number" name="fee_amount['+fee_id+']" class="form-control fee_amount" id="amount'+i+'" value="'+feeAmount+'" required min="'+feeAmount+'">\n' +
                        ' </td>\n' +
                        '<td>\n' +
                        '<button type="button" class="btn btn-sm btn-danger btnRemoveItem"><i class="fa fa-times-circle"></i></button>\n' +
                        '</td>\n' +
                        '</tr>';

                    $('#feeListTable tbody').append(trRow);
                    //calculate sum function call
                    calculateAmounts();


        $('html').on('blur','input.fee_amount',function () {
            calculateAmounts();
        });
                    //list loan js
        $('html').on('change','select[name="member_loan"]',function () {
        //$('select[name="loan_id_filter"]').on('change', function () {
            let loan_id = $(this).val();
            let getUrl = window.loan_get_url + "?loan_id=" + loan_id;
            if (loan_id) {
                Generic.loaderStart();
                axios.get(getUrl)
                    .then((response) => {
                        
                        let maxa =response.data.before.toFixed(2);
                        maxa = maxa * -1;
                         $('#before').val(response.data.before.toFixed(2))
                         $('#after').val(response.data.after.toFixed(2))
                        $('#insurance').val(response.data.insurance.toFixed(2))
                        $('#settlement').val(response.data.settle.toFixed(2))
                        $('#amount5').val(response.data.instalment)
                        $("#amount5").attr({
                            "min" : response.data.instalment, 
                            "max" : maxa         
                            }); 

                        calculateAmounts();
                        Generic.loaderStop();
                    }).catch((error) => {
                    let status = error.response.statusText;
                    toastr.error(status);
                    Generic.loaderStop();

                });
            }
            else {
                // clear section list dropdown
                $('select#loan_id_filter').empty().select2({placeholder: 'Pick a loan...'});
            }
            



        });
                }

            }

        });


        $('html').on('click','button.btnRemoveItem', function(){
            $(this).closest('tr').remove();
            //calculate sum function call
            calculateAmounts();
        });

        $('input[name="discount_amount"]').on('change keyup paste',function () {
            calculateAmounts();
        });

        $('input[name="waiver_amount"]').on('change keyup paste',function () {
            calculateAmounts();
        });


        $('input[name="amount_deposited"]').on('change keyup paste',function () {
            calculateAmounts();
        });

        $('input[name="paid_amount"]').on('change keyup paste',function () {
            calculateAmounts();
        });

        $('html').on('blur','input.fee_amount',function () {
            calculateAmounts();
        });

        $('html').on('blur','#amount5',function () {
            calculateAmounts();
        });

        let calculateAmounts = function () {
            let totalAmount = 0.00;
            let unlocated = 0.00;
            let after = 0.00;

            $('input.fee_amount').each(function (index, element) {
                let feeAmount = parseFloat($(element).val());
                if(feeAmount){
                    totalAmount += feeAmount;
                }
            });

            $('#totalAmount').val(totalAmount.toFixed(2))

            let instAmount = parseFloat($('#amount5').val());
            let balAmount = parseFloat($('input[name="before"]').val());
            if(instAmount){
                after = balAmount + instAmount; 
                $('#after').val(after.toFixed(2))
                }

            let discountAmount = parseFloat($('input[name="discount_amount"]').val());
            if(discountAmount){
                totalAmount -= discountAmount;

            }
            let waiverAmount = parseFloat($('input[name="waiver_amount"]').val());
            if(waiverAmount){
                totalAmount -= waiverAmount;
            }



            let depositedAmount = parseFloat($('input[name="amount_deposited"]').val());
            let transCharge = parseFloat($('input[name="trans_amount"]').val());
            if(transCharge){
              depositedAmount -=transCharge;
            }

            if(depositedAmount){
              depositedAmount -= totalAmount;  
            }
            
            



            $('#unallocatedAmount').val(depositedAmount.toFixed(2));
            $('#netAmount').val(totalAmount.toFixed(2));
            let unlocatedAmo = parseFloat($('input[name="unlocated_amount"]').val());

            let paidAmount = parseFloat($('input[name="paid_amount"]').val());
            if(!paidAmount){
                paidAmount = 0.00;
            }

            $('#dueAmount').val((totalAmount - paidAmount).toFixed(2));
        };

        $('select[name="student_id"]').not('.no-ajax').on('change', function () {
            $('#dueInvoiceList>ul li').remove();
            
           let studentId = $(this).val();
           if(parseInt(studentId)){
               let getUrl = window.getStudentInvoiceAjaxUrl + "?student_id=" + studentId;
               Generic.loaderStart();
               axios.get(getUrl)
                   .then((response) => {
                       // console.log(response);
                       if (response.data.length) {
                           response.data.forEach(function(invoice) {
                               let dueInvoiceHtml = '<li><a href="'+window.invoicePaymentUrl.replace(/\.?0+$/, invoice.id)+'" target="_blank">'+invoice.invoice_no+' <span class="pull-right badge bg-1">'+invoice.due+'</span></a></li>';
                               $('#dueInvoiceList>ul').append(dueInvoiceHtml);

                                 });
                       }
                       Generic.loaderStop();
                   }).catch((error) => {
                   let status = error.response.statusText;
                   toastr.error(status);
                   Generic.loaderStop();
               });
           }
        });

        //payment related js
        $('.btnPaymentDeatils').click(function () {
            let pk = $(this).attr('data-pk');
            let getUrl = window.paymentListUrl.replace(/\.?0+$/, pk);
            $('#paymentListTable tbody').empty();
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    if(response.data.success){
                        response.data.payments.forEach(function(payment, index) {
                            let trRow = '<tr>\n' +
                                '<td>'+(index + 1)+'</td>\n' +
                                ' <td>'+payment.payment_date+'</td>\n' +
                                '<td>\n';
                                if(payment.payment_method =="Bank"){
                                    trRow += payment.bank;
                                }else{
                                    trRow += payment.payment_method;
                                }
                                trRow +='</td>\n' +
                              '<td>'+payment.amount+'</td>\n' +
                                '<td>\n';
                                if(payment.payment_reference){
                                    trRow += payment.payment_reference;
                                }
                                trRow +='</td>\n' +
                                '<td>\n';
                               if(payment.doc.length){
                                   trRow += '<a href="/storage/invoice/'+payment.doc+'" target="_blank" title="document" class="btn-link"><i class="fa fa-download"></i></a>\n';
                               }

                                trRow +='</td>\n' +
                                ' <td>\n' +
                                '<a href="'+window.paymentShoweUrl.replace(/\.?0+$/, payment.id)+'?print_it=1" target="_blank" title="Print" class="btn btn-primary btn-xs"><i class="fa fa-print"></i></a>\n'+
                               '<a href="#" title="Delete" class="btn btn-danger btn-xs btnPaymentDelete" data-pk="'+payment.id+'"><i class="fa fa-times-circle"></i></a>\n'+
                                '</td>\n' +
                                '</tr>';
                            $('#paymentListTable tbody').append(trRow);
                        });

                        $('#modalPaymentDetails').modal('show');
                    }
                    else{
                        toastr.error(response.data.message);
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });




        $('html').on('click','a.btnPaymentDelete', function () {
            let that = this;
            let pk = $(this).attr('data-pk');
            let postUrl = window.paymentDleteUrl.replace(/\.?0+$/, pk);
            Generic.loaderStart();
            axios.post(postUrl)
                .then((response) => {
                    // console.log(response);
                    if(response.data.success){
                        toastr.info(response.data.message);
                        $(this).closest('tr').remove();
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });

    }
    static incomeOrExpenseInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();

        //add page js
        $('#account_head_id').select2({
            placeholder: 'Pick a head',
            data: window.heads,
            allowClear: true,
            templateSelection: function (data, container) {
                $(data.element).attr('data-amount', data.amount);
                return data.text;
            }
        });


        $('.documentUp').change(function(){
            var input = this;
            var url = $(this).val();
            var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
            if (input.files && input.files[0]&& (ext == "png" || ext == "jpeg" || ext == "jpg"
                || ext == "txt" || ext == "text" || ext == "doc" || ext == "docx" || ext == "pdf" || ext == "odt"))
            {
                //validate size
                var sizeImg =input.files[0].size/7024;
                if (sizeImg>7024) {
                    toastr.error("File is too big!");
                    $(input).val('');
                    return false
                }
            }
            else{
                $(input).val('');
            }
        });

        $('select#account_head_id').on('select2:select', function () {
            let head_id = $(this).val();
            if(parseInt(head_id)){
                //check fee type exists or not
                let exists = false;
                $('input[name="head_id[]"]').each(function (index, element) {
                    if($(element).val() == head_id){
                        exists = true;
                        return false;
                    }
                });

                if(exists){
                    toastr.error("Head already added in list!");
                    return false;
                }
                else{
                    let headName = $('#account_head_id').find(':selected').text();
                    let headAmount = $('#account_head_id').find(':selected').data('amount');
                    let trRow = '<tr>\n' +
                        '<td>\n' +
                        ' <span class="text-bold">'+headName+'</span>\n' +
                        '<input type="hidden" value="'+head_id+'" name="head_id[]">\n' +
                        '</td>\n' +
                        '<td>\n' +
                        '<input type="number" name="head_amount['+head_id+']" class="form-control head_amount" value="'+headAmount+'" required min="0">\n' +
                        ' </td>\n' +
                        '<td>\n' +
                        '<button type="button" class="btn btn-sm btn-danger btnRemoveItem"><i class="fa fa-times-circle"></i></button>\n' +
                        '</td>\n' +
                        '</tr>';

                    $('#headListTable tbody').append(trRow);
                    //calculate sum function call
                    calculateIncomeExpenseAmounts();
                }

            }

        });


        $('html').on('click','button.btnRemoveItem', function(){
            $(this).closest('tr').remove();
            //calculate sum function call
            calculateIncomeExpenseAmounts();
        });

        $('html').on('blur','input.head_amount',function () {
            calculateIncomeExpenseAmounts();
        });

        let calculateIncomeExpenseAmounts = function () {
            let totalAmount = 0.00;

            $('input.head_amount').each(function (index, element) {
                let headAmount = parseFloat($(element).val());
                if(headAmount){
                    totalAmount += headAmount;
                }
            });

            $('#totalAmount').val(totalAmount.toFixed(2));
        };


    }
}